import type { FiltersContext } from '../../context/types';
import type { FilterCriteria } from '../types';
import { getFilterOptions } from '../utils';
import { SingleFilter } from './singleFilter/SingleFilter';

type SingleFiltersListProps<Criteria extends FilterCriteria> = {
  filters: FiltersContext<Criteria>['filtersConfig'];
};

export const SingleFiltersList = <Criteria extends FilterCriteria>({ filters }: SingleFiltersListProps<Criteria>) => {
  return (
    <>
      {filters.map(filter => {
        return <SingleFilter key={filter.key} filter={filter} options={getFilterOptions(filter)} />;
      })}
    </>
  );
};
